import React from 'react';
import SubModuleContent from '../../components/SubModuleContent';
import SubModuleHeader from '../../components/SubModuleHeader';
import SubModule from '../../components/SubModule';
import ModuleContent from '../../components/ModuleContent';
import Module from '../../components/Module';
import SendNewEventForm from './SendNewEvent';

const DriManageEvents = () => {
  return (
    <>
      <Module>
        <ModuleContent>
          <SubModule>
            <SubModuleHeader>Send Events</SubModuleHeader>
            <SubModuleContent>
              <SendNewEventForm />
            </SubModuleContent>
          </SubModule>
        </ModuleContent>
      </Module>
    </>
  );
};

export default DriManageEvents;
